import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Topbar from '../components/topbar'; 
import Sidebar from '../components/sidebar'; 
import Footer from '../components/footer'; 

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = `${BASE_URL}admin/getdata/changepassword.php`;

const ChangePassword = () => {

  const [form, setForm] = useState({
    name: "",
    email: "",
    current_password: ""
  });

  const [loading, setLoading] = useState(false);

  /* =============================
     FETCH ADMIN PROFILE
  ============================= */

  const fetchProfile = async () => {
    try {
      const res = await axios.get(`${API_URL}?action=get`);

      if (res.data.success) {
        setForm({
          name: res.data.data.name,
          email: res.data.data.email,
          current_password: res.data.data.password
        });
      }

    } catch (error) {
      console.error("Profile fetch error", error);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  /* =============================
     UPDATE PROFILE
  ============================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await axios.post(`${API_URL}?action=update`, form);

      if (!response.data.success) {
        Swal.fire("Error", response.data.message || "Update failed.", "error");
        setLoading(false);
        return;
      }

      Swal.fire("Success", "Profile updated successfully.", "success");

      setForm({
        ...form,
        current_password: ""
      });

    } catch (error) {
      Swal.fire("Error", "Server error occurred.", "error");
    }

    setLoading(false);
  };

  return (
    <div className="header-light sidebar-dark sidebar-expand">
      <Topbar />
      <div className="content-wrapper">
        <Sidebar />
        <main className="main-wrapper clearfix">
          <div className="widget-list">

            <h4>Admin Profile</h4>

            <div className="card mt-3">
              <div className="card-header">Update Profile</div>
              <div className="card-body">

                <form onSubmit={handleSubmit}>

                  <div className="mb-3">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={form.name}
                      onChange={(e)=>
                        setForm({ ...form, name:e.target.value })
                      }
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={form.email}
                      onChange={(e)=>
                        setForm({ ...form, email:e.target.value })
                      }
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label>Current Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={form.current_password}
                      onChange={(e)=>
                        setForm({ ...form, current_password:e.target.value })
                      }
                      required
                    />
                  </div>

                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Update Profile"}
                  </button>

                </form>

              </div>
            </div>

          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default ChangePassword;